// @flow
import * as React from 'react';
import classNames from 'classnames';
import _ from 'lodash';

import * as css from './Input.scss';

type Props = {
	input: {
		name: string,
		onChange: Function,
		value?: string,
	},
	meta: {
		touched?: boolean,
		error?: string,
		submitFailed?: boolean,
	},
	inputRef?: { current: ?HTMLInputElement } | null,
	className?: string,
	placeholder?: string,
	maxLength: number,
	onFocus: Function,
	authError: string,
};

type State = {
	isActive: boolean,
};

export default class Input extends React.PureComponent<Props, State> {
	static defaultProps = {
		inputRef: null,
		className: '',
		placeholder: '',
	};

	constructor(props: Props) {
		super(props);

		this.state = {
			isActive: false,
		};
	}

	onFocus = (e: SyntheticInputEvent<HTMLInputElement>) => {
		this.setState({ isActive: true });
		this.props.onFocus();
	};

	onBlur = (e: SyntheticInputEvent<HTMLInputElement>) => {
		const input = e.currentTarget;
		this.setState({ isActive: !!input.value });
	};

	render() {
		const { className, placeholder, inputRef, authError, ...rest } = this.props;
		const { isActive } = this.state;
		const value = _.get(rest, 'input.value', '');
		return (
			<label className={classNames(className, (isActive || value) && css.active, css.input)}>
				{placeholder && <span>{placeholder}</span>}
				<input
					{...rest.input}
					value={value}
					ref={inputRef}
					onFocus={this.onFocus}
					onBlur={this.onBlur}
					type="number"
					pattern="[0-9]*"
					inputMode="numeric"
					style={{ color: authError ? '#e42323' : '#686868' }}
				/>
				<div className={css.footer}>
					<div className={css.error}>
						{rest.meta.error && rest.meta.submitFailed && rest.meta.touched && <div>{rest.meta.error}</div>}
					</div>
				</div>
			</label>
		);
	}
}
